import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { IAchivement } from "../../../../components/types/achievements";
import { API } from "../../../../components/API";

import { Flex, Title, Wrapper } from "./AllCollection";

import Skeleton from "../../../../UI/components/UIKit/Skeleton";
import Button from "../../../../UI/components/UIKit/Button";
import AchieveItem from "../../../Achieve/UI/components/AchieveItem";


const Achievements = () => {
    const [ isLoading, setIsLoading ] = useState(true);
    const [ data, setData ] = useState<IAchivement[]>([]);
    const navigate = useNavigate();
    const relocate = () => navigate('/AchievementsPage');
        
    const getData = async () => {
        setIsLoading(true);
        let res = await (await API.achievements.get()).achievements;
        
        setData(res);
        setIsLoading(false);
    };
    
    useEffect(() => { getData(); },[]);

    return (
        <Wrapper>
            <Title>
                <h2>Достижения</h2>
                <Button mini={true} onClick={relocate}><h3>Все</h3></Button>
            </Title>
            <Flex>
                {isLoading ? 
                    Array.from({ length: 3 }, (_, index) => (
                        <Skeleton key={index} width={'40vw'} height={'50vw'} radius={"12px"}/>
                    ))
                    :  
                    data.map((item,index) => <AchieveItem key={item.id} data={item}/>)
                }
            </Flex>
        </Wrapper>
    )
}

export default Achievements
